import './product.scss';
import './img/c-product-1.jpg';

$(document).ready(function(){
  
  // product slider and popup
  if ($(".product-slider").length && $(".product-thumbs").length) {
    var productSlider = new Swiper('.product-slider', { // eslint-disable-line
      spaceBetween: 10,
      // loop: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    });

    var productThumbs = new Swiper('.product-thumbs', { // eslint-disable-line
      spaceBetween: 10,
      centeredSlides: true,
      slidesPerView: 4,
      touchRatio: 0.2,
      slideToClickedSlide: true,
      // loop: true,
    });

    productSlider.controller.control = productThumbs;
    productThumbs.controller.control = productSlider;

    // slider popup
    var productLightbox = $('.product-slider a').simpleLightbox(); // eslint-disable-line
  }
  // eof product slider and popup

  // price range slider
  if (document.getElementById('range-price')) {
    var rangePrice = document.getElementById('range-price'); // eslint-disable-line
    noUiSlider.create(rangePrice, { // eslint-disable-line
      start: [40000, 500000],
      connect: true,
      tooltips: true,
      step: 1,
      format: wNumb({  // eslint-disable-line
        decimals: 0,
        // suffix: 'тис. грн.',
      }),
      range: {
        'min': 20000,
        'max': 800000,
      },
    });
  }
  // eof price range slider

  // tabs switcher
  $(".tabs__switcher").click(function(){
    var targetTab;
    if(!$(this).hasClass("tabs__switcher--active")) {
      targetTab = $(this).attr("data-tab-target");

      $(".tabs__switcher--active").removeClass("tabs__switcher--active");
      $(this).addClass("tabs__switcher--active");

      $(".tabs__item--active").removeClass("tabs__item--active");
      $(".tabs__item[data-tab="+targetTab+"]").addClass("tabs__item--active");
    }
  })
  // eof tabs switcher
});